import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import DateHelpers from '../../lib/DateHelpers';
import { DateTime } from 'luxon';
import { active_clients } from '../../lib/ActiveClients';
import Talent from '../../lib/Talent.js';
import { updateUser } from '../../lib/Users';

class ActiveClients extends React.Component {

  static adminLinkFormatter(cell, row) {
    return `<a target="_blank" href="/users/${row.swipecast_user_id}">${cell}</a>`;
  }

  static mcLinkFormatter(cell, row) {
    return `<a target="_blank" href="${row.mc_link}">${cell}</a>`;
  }

  static L2MFormatter(cell, row) {
    const color = cell == true ? 'transparent' : '#ffcccc';
    return `<div style="background-color:${color}">${cell}</div>`;
  }

  static dateFormatter(cell) {
    if (cell) {
      return `${Math.round(DateHelpers.differenceBetweenTimeStampsInS(Date.now(), cell) / (60 * 60 * 24))} d`;
    }
    return 'N/A';
  }

  state = {
    talents: [],
  };

  componentDidMount() {
    this.getClients();
  }

  static transformClientObjects = (clients) => {
    return clients.map(client => {
      let L12ArrayPosted = {}
      let L12ArrayCompleted = {};
      client.projects.forEach(project => {
        let floorKeyPosted = Math.floor(DateTime.local().diff(DateTime.fromISO(project.created_at)).as('months'));
        // within the year
        if(floorKeyPosted <= 12) {
          if(!L12ArrayPosted[floorKeyPosted]){
            L12ArrayPosted[floorKeyPosted] = 'accounted for';
          }
        }
        project.jobs.forEach(job => {
          let floorKeyCompleted = Math.floor(DateTime.local().diff(DateTime.fromISO(job.created_at_unformatted)).as('months'));
          if(job.status == 'completedJob' || job.status == 'confirmedJob')
          {
            if(floorKeyCompleted <= 12) {
              if(!L12ArrayCompleted[floorKeyCompleted]){
                console.log(job)
                L12ArrayCompleted[floorKeyCompleted] = 'accounted for';
              }
            }
        }
        })
      });
      client['last2M'] = client.projects.filter(project => {
        return DateTime.local().diff(DateTime.fromISO(project.created_at)).as('days') < 60;
      }).length > 0;
      client['L12Posted'] = Object.keys(L12ArrayPosted).length;
      client['L12Completed'] = Object.keys(L12ArrayCompleted).length;
      console.log(client['L12Completed'])
      return client;
    })
  }
  
  getClients = async () => {
    const clientList = await active_clients(1000, 0);
    console.log(clientList);
    const clientObjects = clientList.clients.map(client => new Talent(client));
    console.log(clientObjects)
    this.setState({
      clients: ActiveClients.transformClientObjects(clientObjects),
    });
  }

  onAfterSaveCell = (row, cellName, cellValue) => {
    updateUser(
      row.swipecast_user_id,
      { admin_notes: cellValue },
    );
  }

  render() {
    const { clients } = this.state;
    return (
      <div style={{ width: '100vw' }}>
        <BootstrapTable
          data={clients}
          striped
          hover
          cellEdit={{
            mode: 'dbclick',
            afterSaveCell: this.onAfterSaveCell,
          }}
        >
          <TableHeaderColumn
            row="0"
            dataField="full_name"
            isKey
            dataFormat={ActiveClients.adminLinkFormatter}
            dataAlign="center"
            dataSort
            filter={{ type: 'TextFilter', delay: 300 }}
            editable={false}
          >
              Name
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            dataField="L12Posted"
            dataSort
            editable={false}
          >
            L12 Posted
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            dataField="L12Completed"
            dataSort
            editable={false}
          >
            L12 Completed
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            dataField="last2M"
            dataFormat={ActiveClients.L2MFormatter}
            dataSort
            editable={false}
          >
            Posted job in last 2 months
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            dataField="admin_notes"
            tdStyle={{ whiteSpace: 'normal' }}
          >
            Admin notes
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }
}

export default ActiveClients;
